import Rules, { ValidateRule } from '@lsfe/rules';

export const searchFields = [
    {
        label: 'SPU 名称',
        slot: 'spuName',
        prop: 'spuName',
    },
    {
        label: '分类',
        slot: 'categoryId',
        prop: 'categoryId',
    },
    {
        label: '品牌',
        slot: 'brandId',
        prop: 'brandId',
    },
];

export const tableFields = [
    {
        prop: 'skuName',
        label: '商品名称',
    },
    {
        prop: 'category',
        label: '商品分类',
    },
    {
        prop: 'specification',
        label: '规格',
    },
    {
        prop: 'skuId',
        label: 'SKU ID',
    },
    {
        prop: 'brandName',
        label: '品牌名称',
    },
    {
        prop: 'skuCities',
        label: '售卖城市',
    },
];

function emptyToDefault(val, def = '') {
    if (val == null || val === undefined || val === '' || +val === -1) return def;
    return val;
}

export function initCreateInfoForm(data = {}) {
    return {
        supplierId: emptyToDefault(data.supplierId), // 供货名称
        supplierName: emptyToDefault(data.supplierName), // 供货名称
        misId: emptyToDefault(data.misId), // 采购mis号
        bgCategoryId: emptyToDefault(data.bgCategoryId), // 后台类目
        bgCategoryName: emptyToDefault(data.bgCategoryName), // 后台类目
        categoryId: emptyToDefault(data.categoryId), // 管理类目
        categoryName: emptyToDefault(data.categoryName), // 管理类目
        spuName: emptyToDefault(data.spuName), // SPU名称
        spuBaseId: emptyToDefault(data.spuBaseId), // SPU
        specActual: emptyToDefault(data.specActual), // 规格
        brandId: emptyToDefault(data.brandId), // 品牌
        brandName: emptyToDefault(data.brandName), // 品牌
        taste: emptyToDefault(data.taste), // 口味
        skuName: emptyToDefault(data.skuName), // SKU名称
        marketingWord: emptyToDefault(data.marketingWord),
        commodityName: emptyToDefault(data.commodityName),
        skuType: emptyToDefault(data.skuType), // 加工类型
        cityIds: emptyToDefault(data.cityIds, []), // 售卖城市
        keyAttributes: emptyToDefault(data.keyAttributes, []), // 扩展属性
        dnaAttrs: emptyToDefault(data.dnaAttrs, []), // DNA属性
        packageType: emptyToDefault(data.packageType, 1), // 销售形态 标品1，散装2
        unitId: emptyToDefault(data.unitId), // 单位
        unitName: emptyToDefault(data.unitName),
        standardSpecList: emptyToDefault(data.standardSpecList, []), // 销售规格

        storageTemperatureLevelRemark: emptyToDefault(data.storageTemperatureLevelRemark),
    };
}

const NoSpaceRule = new ValidateRule({
    validator(rule, value, cb) {
        if (/\s/.test(value)) {
            cb(new Error('不能有空格'));
        } else {
            cb();
        }
    },
});

export const formRules = {
    supplierId: [
        Rules.isRequired('供货名称必填'),
    ],
    misId: [
        Rules.isRequired('采购mis号必填'),
    ],
    bgCategoryId: [
        Rules.isRequired('后台类目必填'),
    ],
    categoryId: [
        Rules.isRequired('管理类目必填'),
    ],
    spuName: [
        Rules.isRequired('spu名称必填'),
        Rules.lenRange({ max: 30 }, '名称最多30个字'),
    ],
    specActual: [
        Rules.isRequired('规格必填'),
        Rules.lenRange({ max: 10 }, '规格最多10个字'),
        NoSpaceRule,
    ],
    brandId: [
        Rules.isRequired('品牌必填'),
    ],
    packageType: [
        Rules.isRequired('销售形态必填'),
    ],
    unitId: [
        Rules.isRequired('基础单位必填'),
    ],
    skuType: [
        Rules.isRequired('加工状态必选'),
    ],
    cityIds: [
        Rules.isRequired('请选择'),
        Rules.lenRange({ min: 1 }, '请至少选择一个提报城市'),
    ],
};
